// Owned job photography only; logos and manufacturer style images are excluded.
const BASE_URL = "https://1woodfloors.com";
export const PLANK_HUB_ORGANIZATION_ID = `${BASE_URL}/#organization`;

export const PLANK_JOB_PHOTOS = [
  { baseName: "custom-rift-quarter-walnut", url: `${BASE_URL}/images/projects/walnut-rift-quartered-michigan-plank-floor-dining-area-novi-mi.jpg`, alt: "Dining area with a true random rift and quarter sawn Michigan Plank walnut floor in 2 to 5 inch widths and an eggshell finish, Novi, MI" },
  { baseName: "1-wood-custom-line-8-inch-white-oak-plymouth-mi", alt: "Kitchen with an 8 inch engineered character grade white oak floor in Sand, Plymouth, MI", caption: "Pictured: 8 inch character grade white oak, Plymouth, MI" },
  { baseName: "custom-8-inch-walnut-fas-northville-mi", alt: "Open kitchen with an 8 inch engineered FAS walnut floor, Northville, MI", caption: "Pictured: 8 inch FAS walnut, Northville, MI" },
  { baseName: "custom-nature-white-oak", alt: "Michigan Plank European white oak floor in Nature, Novi, MI", caption: "Pictured: European white oak in Nature, Novi, MI" },
  { baseName: "custom-fireside-hickory", alt: "8 inch engineered Michigan Plank hickory floor in Fireside with a 4mm sawn face on a Baltic birch core, Livonia, MI", caption: "Pictured: 8 inch hickory in Fireside, Livonia, MI" },
  { baseName: "custom-sand-white-oak", alt: "8 inch engineered Michigan Plank white oak floor in Sand, Plymouth, MI", caption: "Pictured: 8 inch white oak in Sand, Plymouth, MI" },
  { baseName: "michigan-plank-hickory-fireside-living-room-sofa-livonia-mi", url: `${BASE_URL}/images/projects/livonia-subfloor/michigan-plank-hickory-fireside-living-room-sofa-livonia-mi.webp`, alt: "Leather sofa on a wide 8 inch engineered Michigan Plank hickory floor in Fireside, Livonia, MI", caption: "Pictured: the same Fireside hickory finished in a Livonia living room" },
];
export const HARDWOOD_JOB_PHOTOS = [
  { baseName: "hardwood-flooring-hub-hero", url: `${BASE_URL}/images/projects/walnut-fas-8-inch-floor-wide-open-room-northville-mi.jpg`, alt: "Wide open room with an 8 inch engineered FAS walnut floor, Northville, MI" },
];
export const PLANK_HUB_PHOTOS = {
  "/michigan-plank-flooring": PLANK_JOB_PHOTOS,
  "/hardwood-flooring": HARDWOOD_JOB_PHOTOS,
};
export const PLANK_HUB_SHARE_IMAGES = Object.fromEntries(
  Object.entries(PLANK_HUB_PHOTOS).map(([path, photos]) => [path, { url: photos[0].url, width: 1920, height: 1920, alt: photos[0].alt }]),
);

export function makePlankHubImageSchemas(path, resolveImage) {
  return (PLANK_HUB_PHOTOS[path] || []).map(photo => {
    const url = photo.url || resolveImage(photo.baseName);
    return {
      "@context": "https://schema.org", "@type": "ImageObject",
      "@id": `${BASE_URL}${path}#photo-${photo.baseName}`,
      contentUrl: url, url, caption: photo.alt, creditText: "1 Wood Floors",
      creator: { "@id": PLANK_HUB_ORGANIZATION_ID }, copyrightHolder: { "@id": PLANK_HUB_ORGANIZATION_ID },
    };
  });
}

export function makePlankHubWebPageSchema(path) {
  const hero = PLANK_HUB_PHOTOS[path]?.[0];
  return {
    "@context": "https://schema.org", "@type": "WebPage", url: `${BASE_URL}${path}`,
    ...(hero ? { primaryImageOfPage: { "@id": `${BASE_URL}${path}#photo-${hero.baseName}` } } : {}),
  };
}